<template>
    <div style="background: #fff;">
        <div class="item_wrap step1">
            <div class="item_imgbox">
                <img :src="item_img1" width="100%" />
            </div>
            <div class="item_btm">
                <div class="item_tit">
                    客情维护定期跟进<br />服务记录一键导出
                </div>
                <div class="item_txt">
                    重要客户经常忘记定期维护？客户积累越来越多，客情如何维护？案件云的客户管理对客户资源集中管理，针对个人、团队客户名下的非诉项目、联系记录、客户发票、合同、以及客户联系人等进行多维度的记录和统计分析，客户关系管理就是这么简单！
                </div>
                <div class="item_btn">
                    <span @click="jumpGuide">立即下载</span>
                </div>
            </div>
        </div>
        <div class="item_wrap1" v-for="(item, index) in wrap_data" :key="index">
            <div class="item_wrap1_tit">{{ item.tit }}</div>
            <p class="item_wrap1_txt" v-html="item.txt"></p>
            <div>
                <img :src="item.img" width="100%" />
            </div>
        </div>
        <div class="ptp50">
            <nowdownload />
        </div>
        <Footer />
    </div>
</template>

<script>
import nowdownload from '@/components/nowdownload/index'
import { Footer } from '@/components'
function requireImg(str) {
    return require("pbimages/cli/" + str);
}
export default {
    components: {
        nowdownload,
        Footer
    },
    data() {
        return {
            item_img1: requireImg("step1.png"),
            wrap_data: [
                {
                    tit: '客情维护',
                    txt: "在案件列表一眼看到该客户最近联络日期，通过日程管理及时提醒跟进、设置拜访计划，提升客户资源转化率。",
                    img: requireImg('step2.png'),
                },
                {
                    tit: '关联批量案件',
                    txt: "在客户中还可以将关联的案件和项目进行统一管理，全局把控客户名下每一起案件和项目的最新动态。",
                    img: requireImg('step3.png'),
                },
                {
                    tit: '客户服务报告',
                    txt: "将每一次跟进客户时间、方式、内容、结果进行记录和管理，导出一份记录报告，便于查询和追溯相关服务信息，从而更好的开展客户服务工作。",
                    img: requireImg('step4.png'),
                },
                {
                    tit: '客户转案件',
                    txt: "当咨询转化为案源后，通过「客户转案件」功能，将前期咨询阶段积累的大量沟通记录、邮件往来、会议纪要等关键信息，以及各类文书资料，无缝转移到案件中。",
                    img: requireImg('step5.png'),
                },
            ],
        }
    },
    mounted() {
    },
    methods: {
        jumpGuide() {
            this.$router.push({ name: 'downApp' })
        },
    }

}
</script>

<style lang="stylus" scoped>
    .item_wrap{
        &.step1{
            //background: linear-gradient(180deg, #F2F8FE 0%, #EAF1FF 100%);
            background: url("../../public/images/case/bg.jpg") no-repeat;
            background-size: cover;
            background-position-x: 70%;
        }
        .item_imgbox{
        padding: 65px 63px 60px;
        }
        .item_btm{
            //background: #F2F3F5;
            padding: 0 0 60px 0;
            .item_tit{
                font-size: 48px;
                font-weight: 800;
                color: #303443;
                line-height: 58px;
                text-align: center;
                
            }
            .item_txt{
                font-size: 26px;
                font-weight: 500;
                color: #5E606B;
                line-height: 46px;;
                padding: 39px 35px 97px;
            }
            .item_btn{
                display: flex;
                justify-content: center;
                span{
                    width: 228px;
                    height: 80px;
                    background: #FABA4A;
                    border-radius: 10px;
                    color: #fff;
                    font-size: 30px;
                    font-weight: bold;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
    .item_wrap1{
        padding: 80px 40px 50px;
        &_tit{
            font-size: 34px;
            font-weight: bold;
            color: #303443;
            text-align: left;
            padding: 0 0 20px 0;
        }
        &_txt{
            font-size: 26px;
            font-weight: 500;
            color: #7E818F;
            line-height: 46px;
            text-align: left;
        }
        &:nth-child(even){
            background: #fff;
        }
        &:nth-child(odd){
            background: #F8F9FB;
        }
    }
    .ptp50{
        padding-top: 50px;
    }
    .tab_wrap{
        display: flex;
        justify-content: center;
        height: 140px;
        background: #F5F8FF;
        .tab_main{
            display: flex;
            align-items: center;
            span{
                font-size: 36px;
                font-weight: 500;
                color: #7E818F;
                display: flex;
                height: 100%;
                align-items: center;
                position relative;
                &:first-child{
                    margin: 0 143px 0 0;
                }
                img{
                    width 40px;
                    margin: 0 8px 0 0;
                }
                &.active{
                    &:after{
                        position: absolute;
                        bottom: 0;
                        width: 100%;
                        background: #303443;
                        height: 4px;
                        content: "";
                    }
                    
                }
            }
        }
    }
</style>